exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "table {\n  margin-top: 12px; }\n\n.w-33 {\n  width: 33%; }\n\n.w-25 {\n  width: 25%; }\n\n.no-mg-top {\n  margin-top: 0px !important; }\n\n.no-card-top {\n  margin-top: -12px !important; }\n\n.card {\n  margin-top: 12px !important; }\n\n.no-alert {\n  font-size: .54167rem;\n  letter-spacing: normal;\n  line-height: .75rem;\n  position: relative;\n  box-sizing: border-box;\n  display: table-row;\n  -webkit-box-orient: horizontal;\n  -webkit-box-direction: normal;\n  -ms-flex-direction: row;\n  flex-direction: row;\n  width: auto;\n  border-radius: 0px;\n  margin-top: auto; }\n\nsmall {\n  margin-left: 2em; }\n\np {\n  margin-top: 6px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/zhaolinxu/GitHub/IdleAnt/src/app/unit/unit.component.scss
// module id = ../../../../../src/app/unit/unit.component.scss
// module chunks = 1